import { toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, Fragment as _Fragment, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-6d71a3d4")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock(_Fragment, null, [
    (!$props.src && !$props.isBadge)
      ? (_openBlock(), _createBlock("div", {
          key: 0,
          class: [$setup.classesName, $setup.backgroundName],
          style: $setup.styles,
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.onClick && $setup.onClick(...args)))
        }, _toDisplayString($props.name), 7))
      : ($props.isBadge && !$props.src)
        ? (_openBlock(), _createBlock("div", {
            key: 1,
            class: "relative inline-block",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => ($setup.onClick && $setup.onClick(...args)))
          }, [
            (!$props.isBadge)
              ? (_openBlock(), _createBlock("img", {
                  key: 0,
                  class: $setup.classes,
                  src: $props.src,
                  alt: "",
                  srcset: ""
                }, null, 10, ["src"]))
              : _createCommentVNode("", true),
            _createVNode("span", { class: $setup.classesBadge }, null, 2)
          ]))
        : _createCommentVNode("", true),
    (!$props.isBadge && $props.src)
      ? (_openBlock(), _createBlock("img", {
          key: 2,
          class: $setup.classes,
          style: $setup.styles,
          src: $props.src,
          alt: "",
          srcset: "",
          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => ($setup.onClick && $setup.onClick(...args)))
        }, null, 14, ["src"]))
      : ($props.src && $props.isBadge)
        ? (_openBlock(), _createBlock("div", {
            key: 3,
            class: "relative inline-block",
            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => ($setup.onClick && $setup.onClick(...args)))
          }, [
            (!$props.isBadge)
              ? (_openBlock(), _createBlock("img", {
                  key: 0,
                  class: $setup.classes,
                  src: $props.src,
                  alt: "",
                  srcset: ""
                }, null, 10, ["src"]))
              : _createCommentVNode("", true),
            _createVNode("span", { class: $setup.classesBadge }, null, 2)
          ]))
        : _createCommentVNode("", true)
  ], 64))
})